(() => {
  const companyId = 'Xqgzi7';
  const scriptSrc = `https://static.klaviyo.com/onsite/js/${companyId}/klaviyo.js?company_id=${companyId}`;

  // Keep Klaviyo calls made by theme/app blocks queued until the library arrives.
  if (!window.klaviyo) {
    window._klOnsite = window._klOnsite || [];
    try {
      window.klaviyo = new Proxy({}, {
        get(_target, method) {
          if (method === 'push') {
            return (...args) => window._klOnsite.push(...args);
          }

          return (...args) => {
            const callback = typeof args[args.length - 1] === 'function' ? args.pop() : null;
            return new Promise((resolve) => {
              window._klOnsite.push([
                method,
                ...args,
                (value) => {
                  callback?.(value);
                  resolve(value);
                },
              ]);
            });
          };
        },
      });
    } catch (_error) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = (...args) => window._klOnsite.push(...args);
    }
  }

  let requested = false;
  let scheduleTimer = null;
  let scheduledDelay = Infinity;

  function loadKlaviyo() {
    if (requested || document.querySelector(`script[src="${scriptSrc}"]`)) return;
    requested = true;

    const script = document.createElement('script');
    script.async = true;
    script.src = scriptSrc;
    document.head.appendChild(script);
  }

  function scheduleKlaviyo(delay = 5000) {
    if (requested) return;

    // A user action can bring the load forward; otherwise wait until the page
    // has settled so the library doesn't compete with first paint.
    if (scheduleTimer && delay >= scheduledDelay) return;
    if (scheduleTimer) window.clearTimeout(scheduleTimer);

    scheduledDelay = delay;
    scheduleTimer = window.setTimeout(() => {
      scheduleTimer = null;
      scheduledDelay = Infinity;
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(loadKlaviyo, { timeout: 2000 });
      } else {
        loadKlaviyo();
      }
    }, delay);
  }

  if (document.readyState === 'complete') {
    scheduleKlaviyo();
  } else {
    window.addEventListener('load', () => scheduleKlaviyo(), { once: true });
  }

  // Start sooner if someone interacts before the load event, but let the current
  // interaction finish before network work begins.
  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach((eventName) => {
    window.addEventListener(eventName, () => scheduleKlaviyo(1000), { once: true, passive: true });
  });
})();
